export enum TipoBaseCalculoParametroImpositivo {
    Neto = 0,
    Total = 1,
    NetoMasImpuestoInterno  = 2,
    NetoMasImpuestoInternoMasTasas = 3
}